import { render } from "./shipping_method.vue?vue&type=template&id=5fcb0a26"
import script from "./shipping_method.vue?vue&type=script&lang=js"
export * from "./shipping_method.vue?vue&type=script&lang=js"

import "./shipping_method.vue?vue&type=style&index=0&id=5fcb0a26&lang=css"

import exportComponent from "/home/raphael/git/proclima/retailerportal/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__